export default {
    route:{
        frame: 'frame'
    },
    project:{
        login: {
            projectName: 'I Have A Great Dream',
            userAccount: 'Account:',
            userAccountPlaceholder: 'Plaese Input The Account',
            userPassword: 'Password:',
            userPasswordPlaceholder:'Plaese Input The Password',
            VerificationCode: 'Code:',
            verificationCodePlaceholder:'Plaese Input The Code',
            userLogin: 'login'
        },
        main:{
            menuLabel: 'Menu Label',
            mainLabel: 'Main Label'
        }
    },
    httpCode:{
        http404: '404 error'
    }
}